import React, { useRef } from 'react';
import { Button, Col, InputGroup, Nav, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { NavLink, useLocation } from 'react-router-dom';
import { MMPProps } from './types';
import { Clipboard } from 'react-bootstrap-icons';
import { config } from '../../config';
import { DEFAULT_LOCATION, resolveLocationFromUrl } from '../../location';

export default function MMP(pageConfig: MMPProps) {
  const { Link } = Nav;
  const location = useLocation();
  const { title, text, communicationText, decisionList } = pageConfig;
  const { Control } = Form;
  const inputRef = useRef<HTMLInputElement>(null);
  const featuresByLocation = config.featuresByLocation as Record<string, unknown> | undefined;
  const locationByHost = config.locationByHost as Record<string, string> | undefined;
  const { locationId, isPathScoped, isKnownLocation } = resolveLocationFromUrl({
    pathname: location.pathname,
    hostname: window.location.hostname,
    featuresByLocation,
    locationByHost,
    defaultLocation: DEFAULT_LOCATION,
  });
  const locationPrefix = isKnownLocation && isPathScoped ? `/${locationId}` : '';
  const getScopedPath = (path: string) =>
    locationPrefix && path.startsWith('/') ? `${locationPrefix}${path}` : path;

  const handleCopy = () => {
    if (inputRef.current) {
      navigator.clipboard.writeText(inputRef.current.value);
    }
  };

  return (
    <div style={{ padding: 40 }}>
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: text }} />
      {communicationText && (
        <InputGroup className="mb-3">
          <Control
            ref={inputRef}
            readOnly
            value={'Here is some text that the user can copy'}
            aria-label="Communication Text"
            aria-describedby="basic-addon2"
          />
          <Button onClick={handleCopy} aria-label="Copy to clipboard">
            <Clipboard size={20} />
          </Button>
        </InputGroup>
      )}
      <hr />
      <Row>
        {decisionList.map((decision) => (
          <Col>
            <div key={decision.id} style={{ marginBottom: 10 }}>
              <Button variant={decision.variant || 'primary'}>
                <Link as={NavLink} to={getScopedPath(decision.navigateTo)}>
                  {decision.text}
                </Link>
              </Button>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export { MMP };
